import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
  Grid,
  Container,
  Avatar,
  Divider,
  Tooltip,
} from "@mui/material";
import { History, AccountBalance } from "@mui/icons-material";
import firebaseApp, { KEY_REF } from "../adm/admin/firebaseConfig";
import { getDatabase, ref, get } from "firebase/database";
import TitleSection from "../utils/TittleTheme";

const DEFAULT_FOTO = "https://st3.depositphotos.com/4111759/13425/v/450/depositphotos_134255588-stock-illustration-empty-photo-of-male-profile.jpg";

const GaleriaPresidentes = () => {
  const [presidentes, setPresidentes] = useState([]);

  useEffect(() => {
    const fetchPresidentes = async () => {
      try {
        if (!KEY_REF) {
          console.error("KEY_REF não definido.");
          return;
        }

        const cacheKey = `galeria_presidentes_cache_${KEY_REF}`;
        const cacheTimestampKey = `galeria_presidentes_timestamp_${KEY_REF}`;
        const cachedData = localStorage.getItem(cacheKey);
        const cacheTimestamp = localStorage.getItem(cacheTimestampKey);
        const now = Date.now();

        if (cachedData && cacheTimestamp && now - cacheTimestamp < 30 * 60 * 1000) {
          setPresidentes(JSON.parse(cachedData));
          return;
        }

        const databaseInstance = getDatabase(firebaseApp);
        const presidentesRef = ref(databaseInstance, `galeria_presidentes`);
        const snapshot = await get(presidentesRef);

        const data = snapshot.val();

        if (data) {
          const presidentesArray = Object.keys(data).map((key) => ({
            id: key,
            nome: data[key].nome || "Sem Nome",
            partido: data[key].partido || "Sem Informação",
            ano_inicial: data[key].ano_inicial || "N/A",
            ano_final: data[key].ano_final || "N/A",
            foto: data[key].foto || DEFAULT_FOTO,
          }));

          // Ordenar dos mais recentes para os mais antigos (ano_final descendente, depois ano_inicial descendente)
          presidentesArray.sort((a, b) => {
            const finalB = parseInt(b.ano_final) || 0;
            const finalA = parseInt(a.ano_final) || 0;
            if (finalB !== finalA) return finalB - finalA;
            return (parseInt(b.ano_inicial) || 0) - (parseInt(a.ano_inicial) || 0);
          });

          localStorage.setItem(cacheKey, JSON.stringify(presidentesArray));
          localStorage.setItem(cacheTimestampKey, now.toString());

          setPresidentes(presidentesArray);
        } else {
          console.warn("Nenhum dado encontrado para galeria de presidentes.");
          setPresidentes([]);
        }
      } catch (error) {
        console.error("Erro ao buscar a galeria de presidentes:", error);
      }
    };

    fetchPresidentes();
  }, [KEY_REF]);

  return (
    <Box sx={{ marginTop: 3 }}>
      <TitleSection
        title="GALERIA DOS PRESIDENTES"
        subtitle="Conheça a trajetória dos líderes que guiaram nossa câmara municipal ao longo dos anos, promovendo o desenvolvimento e a representação da comunidade."
      />
      <Container maxWidth="lg" sx={{ paddingX: { xs: 2, md: 2 }, marginY: 3 }}>
        <Grid container spacing={3}>
          {presidentes.map((presidente) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={presidente.id}>
              <Tooltip title={`Mandato: ${presidente.ano_inicial} - ${presidente.ano_final}`} arrow>
                <Card
                  sx={{
                    "&:hover": { boxShadow: 6 },
                    height: "100%",
                    borderRadius: "12px",
                    textDecoration: "none",
                    background: "linear-gradient(135deg, #2A2A2A 0%, #3A3A3A 100%)",
                  }}
                >
                  <CardActionArea sx={{ textDecoration: "none" }}>
                    <CardMedia
                      component="img"
                      height="240"
                      image={presidente.foto}
                      alt={presidente.nome}
                      sx={{ objectFit: "cover", borderRadius: "12px 12px 0 0" }}
                    />
                    <CardContent sx={{ textAlign: "center", padding: 2 }}>
                      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, textDecoration: "none" }}>
                        <Avatar sx={{ bgcolor: "primary.main", width: 28, height: 28 }}>
                          <History sx={{ fontSize: 18 }} />
                        </Avatar>
                        <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "1.1rem", textDecoration: "none", color: "#FFF" }}>
                          {presidente.nome}
                        </Typography>
                      </Box>
                      <Divider sx={{ marginY: 1, borderColor: "#0F71FD" }} />
                      <Typography variant="body2" sx={{ fontSize: "0.9rem", color: "#DDD", textDecoration: "none" }}>
                        <AccountBalance sx={{ fontSize: 16, verticalAlign: "middle", marginRight: 0.5 }} /> {presidente.partido}
                      </Typography>
                      <Typography variant="body2" sx={{ fontSize: "0.9rem", color: "#BBB", mt: 1 }}>
                        Mandato: {presidente.ano_inicial} - {presidente.ano_final}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Tooltip>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default GaleriaPresidentes;